import { render, staticRenderFns } from "./AlertNotFoundCampanha.vue?vue&type=template&id=10e24524&scoped=true"
import script from "./AlertNotFoundCampanha.vue?vue&type=script&lang=js"
export * from "./AlertNotFoundCampanha.vue?vue&type=script&lang=js"
import style0 from "./AlertNotFoundCampanha.vue?vue&type=style&index=0&id=10e24524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e24524",
  null
  
)

export default component.exports